import { InjectionToken, Inject } from '@angular/core';

export const DATE_LOCALE_TOKEN = new InjectionToken<string>('DATE_LOCALE');
const DateTimeFormat = localStorage.getItem('dateFormate') || 'MM/DD/YYYY';

export const DATEPICKER_FORMATS = {
  parse: {
    dateInput: DateTimeFormat,
  },
  display: {
    dateInput: DateTimeFormat,
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
